import {
  PatientInfo, ProductInfo, AddProductInfo, EmailReason,
  SAVED_FLAG, IEmailTemplate, ORDER_FLAG,
} from './visits.constant';
import { ITEMPLATE } from './cmnTemplateForEversense.constant';
import { modalWidth, modalHeight, modalTop, modalLeft } from '../components/subComponents/commonModal/v3';
import { createColumn, ColumnType } from '../components/subComponents/table';
import TextFileIcon from '../assets/textFile.svg';
import ImageFileIcon from '../assets/imageFile.svg';
import PdfFileIcon from '../assets/pdfFile.svg';

export const INNER_HEIGHT = 720;

export const PRODUCT_TITLE_HEIGHT = 52;

const mWV3 = () => {
  const standardWidth = modalWidth.xl;
  if (window.innerWidth > standardWidth) {
    return standardWidth;
  }
  return window.innerWidth - 32;
};

const mHV3 = () => {
  return window.innerHeight - 32;
};

export const DIMENSION = {
  SMALL: {
    minWidth: modalWidth.xs,
    width: modalWidth.xs + 32,
    minHeight: modalHeight.xs,
    height: modalHeight.xs - 4,
    top: modalTop.s,
    left: modalLeft.s,
  },
  STANDARD: {
    minWidth: modalWidth.s,
    width: modalWidth.s + 32,
    minHeight: modalHeight.s,
    height: modalHeight.s - 4,
    top: modalTop.s,
    left: modalLeft.s,
  },
  REGULAR: {
    minWidth: modalWidth.s,
    width: modalWidth.m + 32,
    minHeight: modalHeight.s,
    height: modalHeight.s2 - 4,
    top: modalTop.m,
    left: modalLeft.m,
  },
  REGULAR2: {
    minWidth: modalWidth.s,
    width: modalWidth.s + 32,
    minHeight: modalHeight.s,
    height: modalHeight.s2 - 4,
    top: modalTop.m,
    left: modalLeft.m,
  },
  BIGGER: {
    minWidth: modalWidth.m,
    width: modalWidth.m + 32,
    minHeight: modalHeight.s,
    height: modalHeight.m - 4,
  },
  BIGGER2: {
    minWidth: modalWidth.m,
    width: modalWidth.m + 32,
    maxWidth: modalWidth.m + 32,
    minHeight: modalHeight.s,
    height: modalHeight.s2 - 4,
  },
  BIGGER3: {
    minWidth: modalWidth.m,
    width: mWV3(),
    maxWidth: modalWidth.xl + 32,
    minHeight: mHV3(),
  },
  BIGGER4: {
    minWidth: modalWidth.m,
    width: mWV3(),
    maxWidth: modalWidth.xl + 32,
    minHeight: modalHeight.s,
    height: modalHeight.s2 - 4,
  },
};

export const CONSULT_TYPE = {
  medications: 'PersonalMedicatoins',
  allergies: 'Allergies',
  illnesses: 'SeriousIllness',
};

export const PROMISE_STATUS = {
  rejected: { status: 'rejected' },
  fulfilled: { status: 'fulfilled' },
};

export const APPROVAL_TYPE = {
  disqualified: 'Disqualified',
  approved: 'Approved',
  denied: 'Denied',
  noApprovalInfo: 'No Approval Info',
  cancelled: 'Cancelled',
  fullfilled: 'Fullfilled',
};

export const PRODUCT_APPROVAL_TYPE = {
  Cancelled: 'Cancelled',
  MedicallyDenied: 'Medically Denied',
};

export const VISIT_TYPE = {
  ASYNC: 'Asynchronous Order',
  SCHEDULED: 'Scheduled Visit',
};

export const BOOLEAN = {
  true: 'Yes',
  false: 'No'
};

export const MODAL_KEY = {
  CALL_PATIENT: 'call-patient',
  TEXT_PATIENT: 'text-patient',
  EMAIL_PATIENT: 'email-patient',
  ADD_NEW_PRODUCT: 'add-new-product',
  CHANGE_PRODUCT: 'change-product',
  APPROVE: 'approve',
  DENY: 'deny',
  SOAP_NOTE: 'soap-note',
  ADD_NOTE: 'add-note',
  SEND_TO_PS: 'send-to-ps',
  TWILIO: 'twilio',
  FLAGS: 'flags',
  EXTENDED_CONSULT: 'extended-consult',
  DOSESPOT_JUMPSTART: 'dosespot-jumpstart',
  CHANGE_TASK_STATUS: 'change-task-status',
  GLOBAL_ICD10_CODES: 'global-icd10-codes',
};

export const CONFIRMATION_POPUP_KEY = {
  CALL_PATIENT: 'call-patient-close-confirmation',
  TEXT_PATIENT: 'text-patient-close-confirmation',
  EMAIL_PATIENT: 'email-patient-close-confirmation',
  ADD_NEW_PRODUCT: 'add-new-product-confirmation',
  ADD_NEW_PRODUCT_CLOSE: 'add-new-product-close-confirmation',
  CHANGE_PRODUCT: 'change-product-confirmation',
  CHANGE_PRODUCT_CLOSE: 'change-product-close',
  APPROVE: 'approve-confirmation',
  DENY: 'deny-confirmation',
  SOAP_NOTE: 'soap-note-confirmation',
  ADD_NOTE: 'add-note-confirmation',
  SEND_TO_PS: 'send-to-ps-confirmation',
  FLAGS: 'flags-confirmation',
  EXTENDED_CONSULT: 'extended-consult-confirmation',
  DOSESPOT_JUMPSTART: 'dosespot-jumpstart-confirmation',
  DOSESPOT_JUMPSTART_CLOSE: 'dosespot-jumpstart-close-confirmation',
  CHANGE_TASK_STATUS: 'change-task-status-confirmation',
  CHANGE_TASK_STATUS_CLOSE: 'change-task-status-close-confirmation',
  GLOBAL_ICD10_CODES: 'global-icd10-codes-confirmation',
};

export const RESPONSE_POPUP_KEY = {
  CALL_PATIENT: 'call-patient-response',
  TEXT_PATIENT: 'text-patient-response',
  EMAIL_PATIENT: 'email-patient-response',
  ADD_NEW_PRODUCT: 'add-new-product-response',
  CHANGE_PRODUCT: 'change-product-response',
  APPROVE: 'approve-response',
  DENY: 'deny-response',
  SOAP_NOTE: 'soap-note-response',
  ADD_NOTE: 'add-note-response',
  SEND_TO_PS: 'send-to-ps-response',
  FLAGS: 'flags-response',
  EXTENDED_CONSULT: 'extended-consult-response',
  DOSESPOT_JUMPSTART: 'dosespot-jumpstart-response',
  CHANGE_TASK_STATUS: 'change-task-status-response',
  GLOBAL_ICD10_CODES: 'global-icd10-codes-response',
  ORDER_ICD10_CODES: 'order-icd10-codes-response',
};

export const INFO_CARD_THEME = {
  INFO: 'info-card',
  ALERT: 'alert-card',
};

export const NOT_AVAILABLE = 'NA';

export const TRUE = 'true';

export const TAB_DETAILS_SCREEN_RESIZE_DELAY = 300;

export const VISITS_URL = '/visits?version=2';

export const VISITS_URL_V1 = '/visits';

export const VISITS_URL_V2 = '/scheduled-visits';

export const ASYNC_ORDERS_URL = '/async-orders';

export const NOTE_ANALYTICS_LOADER = 'note-analytics-loader';

export const DOSESPOT_JUMP_START_LOADER = 'dosespot-jumpstart-loader';

export const PAGE_HEADING_SELECTOR = '.patient-chart-heading';

export const ORDER_HEADING_SELECTOR = '.patient-chart-order-heading';

export const ORDER_DETAILS_SELECTOR = '.patient-chart-info-section-a';

export const PRODUCTS_TABS_WRAPPER_SELECTOR = '.patient-chart-info-section-b-products-wrapper';

export const TABS_WRAPPER_SELECTOR = '.patient-chart-info-section-b-products-tab-wrapper';

export const VIDEO_VISIT_WRAPPER_SELECTOR = '.patient-chart-info-section-b-video-visit';

export const PATIENT_CHART_INFO_COLUMN_SELECTOR = '.patient-chart-info-section-b-patient-info-column-a';

export const TABS_DETAILS_SELECTOR = '.patient-chart-info-section-b-tab-details-column-a .column-content';

export const EXTENDED_INFO_SELECTOR = '.patient-chart-info-section-b-patient-info-column-a';

export const FLAGS_COLUMN_SELECTOR = '.patient-chart-info-section-b-flags-and-icd-10-codes'

export const FLAG_PERMISSION_ERROR_MESSAGE = 'You do not have permission to modify the flags';

export const FLAG_CHECKBOX_NOT_EDITABLE_MESSAGE = 'With notes checkbox can not be unchecked';

export const ALLOW_ADD_PRODUCT_TO_ORDER_APP_SETTING = 'AllowAddProductToOrder';

export const PATIENT_TOKEN_MAPPING = [
  {
    key: '<<PRE_NAME>>',
    target: 'PreName',
  },
  {
    key: '<<FIRST_NAME>>',
    target: 'FirstName',
  },
  {
    key: '<<LAST_NAME>>',
    target: 'LastName',
  },
  {
    key: '<<AGE>>',
    target: 'Age',
  },
  {
    key: '<<GENDER>>',
    target: 'Gender',
  },
  {
    key: '<<WEIGHT>>',
    target: 'Weight',
  },
  {
    key: '<<HEIGHT>>',
    target: 'Height',
  },
  {
    key: '<<BMI>>',
    target: 'BMI',
  }
];

export const VISIT_URL = new Map([
  [VISIT_TYPE.ASYNC, ASYNC_ORDERS_URL],
  [VISIT_TYPE.SCHEDULED, VISITS_URL_V2],
]);

export const BOTTOM_GUTTER = new Map([
  [true, 'm-b-6'],
  [false, '']
]);

export const FILE_ICON_COLLECTION = new Map([
  ['gif', ImageFileIcon],
  ['png', ImageFileIcon],
  ['jpg', ImageFileIcon],
  ['jpeg', ImageFileIcon],
  ['heic', ImageFileIcon],
  ['heif', ImageFileIcon],
  ['pdf', PdfFileIcon],
  ['txt', TextFileIcon],
]);

export const MIME_TYPE_COLLECTION = new Map([
  ['gif', 'image/gif'],
  ['png', 'image/png'],
  ['jpg', 'image/jpeg'],
  ['jpeg', 'image/jpeg'],
  ['heic', 'image/heic'],
  ['heif', 'image/heif'],
  ['pdf', 'application/pdf'],
  ['txt', 'text/plain']
]);

export const PRODUCTS_COLUMNS = [
  createColumn({ key: 'CheckBox', label: '', type: ColumnType.jsx, width: 30, hideSort: true, action: true, }),
  createColumn({ key: 'displayTitle', label: 'Product', tooltip: 'Product Name', type: ColumnType.string, width: 200 }),
  createColumn({ key: 'DoseSpotJumpStart', label: '', type: ColumnType.jsx, width: 15, hideSort: true, action: true, }),
  createColumn({ key: 'EditIcon', label: '', type: ColumnType.jsx, width: 15, hideSort: true, action: true, }),
  createColumn({ key: 'Qty', label: 'Qty', type: ColumnType.numeric, width: 60 }),
  createColumn({ key: 'OrderType', label: 'Order Type', tooltip: 'Order Type', type: ColumnType.numeric, width: 100 }),
  createColumn({ key: 'status', label: 'Status', type: ColumnType.numeric, width: 100 }),
  createColumn({ key: 'pharmacy', label: 'Pharmacy', type: ColumnType.numeric, width: 140 }),
  createColumn({ key: 'autoRefill', label: 'Auto Refill', tooltip: 'Auto Refill', type: ColumnType.numeric, width: 60 }),
  createColumn({ key: 'shipping', label: 'Shipping', type: ColumnType.numeric, width: 100 }),
];

export const EXPAND_MORE_ICON_CLASS = new Map([
  [false, 'expand-icon'],
  [true, 'expand-icon reverse-icon'],
]);

export const Eversesnse = 'Eversense';

export const Axena = 'Axena';

export const Dexcom = 'Dexcom';

export const Apretude = 'Apretude';

export const Vyepti = 'Vyepti';

export const APPROVAL_VALIDATION_FIELD = {
  eversenseTemplate: 'eversenseTemplate',
  axenaTemplate: 'axenaTemplate',
  dexcomTemplate: 'dexcomTemplate',
  apretudeTemplate: 'apretudeTemplate',
  vyeptiTemplate: 'vyeptiTemplate',
  subjectLine: 'subjectLine',
  emailMessage: 'emailMessage',
  DaysSupply: 'DaysSupply',
  Refills: 'Refills',
  Note: 'Note',
  Sig: 'Sig',
  pin: 'pin',
};

export const ALLOWED_KEY_CODE = new Set([
  48, 49, 50, 51, 52, 53, 54, 55, 56, 57, // numeric keys
  96, 97, 98, 99, 100, 101, 102, 103, 104, 105, // numeric keys from numeric keypad
  37, 38, 39, 40, // arrow keys
  8, 127, // backspace & delete
  9, // tab
  16, // shift
]);

export const PRODUCT_TYPE = {
  alternateRx: 'alternateRx',
  regularRx: 'regularRx',
  lab: 'lab',
};

export const ACTION_TYPE = {
  alternateRx: 'alternateRx',
  regularRx: 'regularRx',
  lab: 'lab',
};

export const PRODUCT = () => ({
  AutRefill: false,
  IsAlternateRx: false,
  IsLabProduct: false,
  OrderType: '',
  Pharmacy: '',
  PrescriberProductDisplayName: '',
  ProductId: 0,
  ProductName: '',
  ProductTitle: '',
  Qty: 0,
  RequiresPrescription: 0,
  Shipping: '',
  Status: '',
  checked: false,
  displayTitle: '',
});

export const NO_CMN_UI = () => ({ template: null, ...ITEMPLATE({}) });

export const PATIENT = () => PatientInfo().selectedPatientInfo;

export const PRODUCT_INFO = () => ProductInfo().productInfo;

export const ADD_PRODUCT_INFO = () => AddProductInfo().addProductInfo;

export const INTAKE = () => {
  const _interface = {
    api: {
      data: {},
      called: false,
      loading: false,
    },
    OrderId: 0,
    ProductConsultDetails: [
      {
        ProductId: 0,
        ProductTitle: '',
        QuestionAnswers: [
          {
            ConsultId: 0,
            QuestionId: 0,
            Flagged: false,
            QuestionText: '',
            AnswerText: '',
            AnswerType: '',
            EntryDate: '',
            ExpectedAnswer: '',
          }
        ],
      }
    ],
    consultIds: new Set([0]),
    consultId: 0,
  };
  _interface.consultIds.delete(0);
  return _interface;
};

export const PRESCRIBER = () => ({
  Message: 'Welcome',
  Prefix: '',
  FirstName: '',
  LastName: '',
  SurveyLink: '',
});

export const MESSAGE = () => ({
  value: -1,
  template: {
    display: '',
  }, 
});

export const EMAIL = () => ({
  value: -1,
  reason: EmailReason(),
  template: {},
  subject: { EmailTemplateBody: '', EmailTemplateSubject: '' },
  sendTextToPatient: true,
});

export const PRODUCT_TO_BE_ADDED = () => ({
  value: -1,
  summary: {
    productId: 0,
    product: '',
    pharmacy: '',
    shipper: '',
    quantity: 0,
  },
});

export const PRODUCT_TO_BE_CHANGED = () => ({
  product: PRODUCT(),
  changedProduct: -1,
  quantity: -1,
  reasonForChange: '',
});

export const SEND_TO_PS = () => ({
  value: -1,
  summary: {
    note: '',
  },
});

export const SOAP_TEMPLATES = () => ({
  value: -1,
  valuesCollection: new Map([[-1, DROPDOWN()]]),
  api: {
    data: [DROPDOWN()],
    called: false,
    loading: false,
  },
});

export const SOAP = () => ({
  value: -1,
  note: '',
});

export const DROPDOWN = () => ({
  id: -1,
  value: -1,
  label: '',
  description: '',
});

export const QUANTITY_RANGE = () => {
  const _interface = {
    defaultQty: -1,
    pId: 0,
    quantities: [DROPDOWN()],
  };
  _interface.quantities = [];
  return _interface;
};

export const QUANTITY_RANGE_RESPONSE = () => ({
  api: {
    called: false,
    loading: false,
    data: QUANTITY_RANGE(),
  },
});

export const SEND_TO_PS_REASONS = () => ({
  api: {
    data: [DROPDOWN()],
  },
  valuesCollection: new Map([
    [-1, DROPDOWN()]
  ])
});

export const ADD_NOTE = () => ({
  noteText: '',
  addPatientNote: false,
});

export const DENY = () => ({
  product: PRODUCT(),
  value: -1,
  reason: EmailReason(),
  template: {},
  subject: { EmailTemplateBody: '', EmailTemplateSubject: '' },
  sendTextToPatient: true,
});

export const FLAG_INPUT_V2 = () => ({
  ...ORDER_FLAG(),
  flagType: '',
});

export const FLAG_INPUTS_V2 = () => {
  let _interface = [FLAG_INPUT_V2()];
  _interface = [];
  return _interface;
};

export const FLAG_INPUT = () => SAVED_FLAG();

export const FLAG = () => {
  const _interface = {
    input: new Map([
      ['', FLAG_INPUT()],
    ]),
  };
  _interface.input.delete('');
  return _interface;
};

export const EXTENDED_FLAG = () => ({
  editMode: false,
  prev: FLAG(),
  current: FLAG()
});

export const EXTENDED_CONSULT = () => ({
  prev: {
    medications: '',
    allergies: '',
    illnesses: '',
  },
  current: {
    medications: '',
    allergies: '',
    illnesses: '',
  },
});

export const STOREFRONT_HISTORY = () => ({
  medications: '',
  icd10Codes: '',
});

export const IPRODUCT_COLLECTION = () => ({
  id: 0,
  value: 0,
  title: '',
  label: '',
  summary: {
    autoRefill: false,
    pharmacy: '',
    shipper: '',
    quantity: 0,
  },
});

export const EMAIL_MESSAGE = () => ({
  Id: '',
  EntryDate: '',
  Message: '',
  RecipientEmailAddress: '',
  RecipientName: '',
  SenderEmailAddress: '',
  SenderName: '',
  Subject: '',
});

export const BOUNDING_CLIENT_RECT = () => ({
  bottom: 0,
  height: 0,
  left: 0,
  right: 0,
  top: 0,
  width: 0,
  x: 0,
  y: 0,
});

export const PRESCRIPTION = () => ({
  Strength: '',
  StrengthMeasure: '',
  NPI: '',
  Qty: 0,
  DaysSupply: 0,
  Expiry: '',
  IsAlternateRx: false,
  ProductIdForKit: 0,
  NotePrefix: '',
  Note: '',
  Refills: {
    DefaultOption: '0',
    IsEditable: false,
    RefillOptions: ['0'],
  },
  Sig: '',
  SubstitutionAllowed: '',
  TotalPills: 0,
  Patient: '',
  Pharmacy: '',
  Prescriber: '',
  Prescribed: '',
  DoctorId: 0,
  ProductId: 0,
  ProductTitle: '',
  ProductType: '',
  PharmacyId: 0,
});

export const APPROVAL_INFO = () => {
  const _interface = {
    api: {
      data: [PRESCRIPTION()],
      called: false,
      loading: false,
    },
  };
  _interface.api.data = [];
  return _interface;
};

export const KIT_EMAIL = () => ({
  value: -1,
  templateTitle: '',
  subjectLine: '',
  emailMessage: '',
});

export const KIT = () => {
  const collection = new Map([
    ['', {
      kitPId: 0,
      items: [PRESCRIPTION()],
      email: KIT_EMAIL(),
    }],
  ]);
  collection.delete('');
  return collection;
};

export const APPROVAL_VALIDATION_ERROR = () => {
  const _interface = new Map([
    ['', { field: '', message: '' }],
  ]);
  _interface.delete('');
  return _interface;
};

export const SF_EMAIL_TEMPLATES = () => {
  const _interface = {
    data: [IEmailTemplate()],
    subjects: {
      called: false,
      loading: false,
      data: new Map([
        [-1, IEmailTemplate()],
      ]),
    },
  };
  _interface.data = [];
  _interface.subjects.data.delete(-1);
  return _interface;
};

export const DOSE_SPOT = () => ({
  StringValue: '',
  openCommonModal: false,
});

export const PRODUCT_IN_HISTORY = () => ({
  ProductId: 0,
  ProductTitle: '',
  displayTitle: '',
  PrescriberProductDisplayName: '',
  OrderType: '',
  ApprovalStatus: '',
});

export const HISTORY = () => {
  const _interface = {
    OrderDate: '',
    OrderId: 0,
    OrderStatus: '',
    Products: [PRODUCT_IN_HISTORY()],
  };
  _interface.Products = [];
  return _interface;
};

export const CRITICAL_NOTE = () => ({
  NoteText: '',
  Required: false,
});

export const NOTE_ANALYTICS = () => ({
  approval: '', // No Approval Info
});

export const NOTE_ANALYTICS_BY_ORDER = () => {
  const _interface = new Map([
    [0, NOTE_ANALYTICS()],
  ]);
  _interface.delete(0);
  return _interface;
};

export const JODIT_EDITOR = () => ({
  text: '',
  value: '',
});

export const JODIT_EDITOR_TEMPLATE_FOR_KIT = () => {
  const collection = new Map([
    ['', {
      name: '',
      editorState: JODIT_EDITOR(),
    }],
  ]);
  collection.delete('');
  return collection;
};

export const JODIT_CONFIG = () => ({
  id: '',
  name: '',
  className: '',
  editorRef: { current: new Map() },
  value: '',
  extras: {},
  onChange: () => {},
});

export const TASK_STATUS = () => ({
  orderNote: '',
  orderId: 0,
  patientId: 0,
  id: '',
  status: '',
  sendTextToPatient: false,
});

export const JUMP_START_INFO = () => ({ productId: 0, orderId: 0, url: '' });

export {
  TextFileIcon,
  ImageFileIcon,
  PdfFileIcon,
};
